export default class Criteria {

    public year: number = null;
    public startDate: Date = null;
    public endDate: Date = null;
    public keywords: Array<string> = null;
    public categories: Array<string> = null;
    public statuses: Array<number> = null;

    constructor() {
        this.keywords = new Array<string>();
        this.categories = new Array<string>();
        this.statuses = new Array<number>();
    }

}